export default __webpack_public_path__ + "static/media/neptun4.364a51ca.jpg";